import { compositionConstants } from '../constant/composition'


export default function composition(state = {}, action) {
  switch (action.type) {

    case compositionConstants.READ_COMPOSITIONS_SUCCESS:
      return { ...state, totalCount: action.resp.totalCount }

    // case compositionConstants.READ_COMPOSITIONS_SUCCESS:
    //   return { ...state, readAll: action.resp, isReady: true }

    // case compositionConstants.READ_COMPOSITIONS_FAILURE:
    //   return { ...state, isReady: true }

    default:
      return state
  }
}